import { ContactFormValues } from 'app/contact/ContactFormValues'

export const submitForm = async (data: ContactFormValues): Promise<boolean> => {
  const formData = new FormData()

  const form = {
    name: data.name,
    surname: data.surname,
    company: data.company,
    interest: data.interest,
    budget: data.budget,
    email: data.email,
    phoneNumber: data.phoneNumber,
    about: data.about,
    token: data.token,
  }

  if (data.files) {
    for (let i = 0; i < data.files.length; i++) {
      formData.append('files', data.files[i], data.files[i].name)
    }
  }

  formData.append('data', JSON.stringify(form))

  const response = await fetch('/api/contact', {
    method: 'POST',
    body: formData,
  })

  const result = await response

  return result.ok
}
